import React, { FC } from 'react';
import { SelectArrayInput, ReferenceArrayInput, useTranslate } from 'react-admin';
import { l } from '~/utils/solutions';
import { useStyles } from '~/hooks/useSolutionsStyles';
import { JsonInput } from './JsonInput';
import ProcessingFlowSelect from '~/components/ProcessingFlowSelect';

interface IndividualRemittanceFormProps {
  keyName: string;
  basePath: string;
}
export const IndividualRemittanceForm: FC<IndividualRemittanceFormProps> = ({
  keyName,
  basePath,
}) => {
  const classes = useStyles();
  const translate = useTranslate();
  const t = (key: string): string => translate(l(`featuresConfig.${key}`));
  return (
    <>
      <ReferenceArrayInput
        source={`${keyName}.accounts`}
        reference='tenant/accounts'
        basePath={basePath}
        label={t('tenantAccounts')}
        className={classes.inputWidth}
        perPage={100}
      >
        <SelectArrayInput optionText='alias' />
      </ReferenceArrayInput>
      <JsonInput
        label={t('remittanceAdditionalPropertiesSchema')}
        source={`${keyName}.additionalPropertiesSchema`}
        className={classes.schemaInput}
        validationError={t('jsonError')}
      />
      <ProcessingFlowSelect sourceBase={`${keyName}.`} />
      <JsonInput
        label={t('processingParameters')}
        source={`${keyName}.processing.parameters`}
        validationError={t('jsonError')}
      />
    </>
  );
};
